<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAlertDecagramOutline } from "@mdi/js";
export default {
  name: "MdiAlertDecagramOutline",
  data() {
    return {
      svgPath: mdiAlertDecagramOutline,
    };
  },
};
</script>
